// import hooks
import { useState } from "react";
import useMediaQuery from "../../../../hooks/useMediaQuery/index.js";
export const useSearchBarOpen = ({ overwriteClick, resetSearchValue, preloadSearch, }) => {
    const isSmallDevice = useMediaQuery(({ breakpoints }) => breakpoints.down("expanded"));
    const [open, setOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const preloadSearchData = (isOpen) => {
        if (isOpen && !!preloadSearch && !preloadSearch.data) {
            void preloadSearch.onLoad?.();
        }
    };
    const toggleSearch = () => {
        setOpen((o) => {
            const newState = !o;
            preloadSearchData(newState);
            return newState;
        });
    };
    const toggleMobileSearch = () => {
        setMobileOpen((o) => {
            const newState = !o;
            preloadSearchData(newState);
            return newState;
        });
    };
    const closeSearch = () => {
        setOpen(false);
    };
    const closeMobileSearch = () => {
        setMobileOpen(false);
    };
    return {
        isOpen: preloadSearch?.isLoading || open || mobileOpen,
        close: () => {
            closeSearch();
            resetSearchValue();
        },
        mobileOpen,
        setMobileOpen,
        mobileClose: () => {
            closeMobileSearch();
            resetSearchValue();
        },
        toggleHandler: () => {
            if (overwriteClick) {
                overwriteClick();
            }
            else {
                if (isSmallDevice) {
                    toggleMobileSearch();
                    closeSearch();
                }
                else {
                    toggleSearch();
                    closeMobileSearch();
                }
            }
        },
        closeDesktopAndMobile: () => {
            closeSearch();
            closeMobileSearch();
            resetSearchValue();
        },
        responsiveToggleHandler: () => {
            if (isSmallDevice) {
                toggleMobileSearch();
            }
            else {
                toggleSearch();
            }
        },
    };
};
export default useSearchBarOpen;
